// extracted by mini-css-extract-plugin
module.exports = {"tableContainer":"paginated-table_tableContainer__1RNMD"};